/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import auth_guid from "../auth_guid.json"
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig = {
  auth: {
    clientId: auth_guid.local.tenantId, // This is the ONLY mandatory field that you need to supply.
    // authority: 'https://Enter_the_Tenant_Subdomain_Here.ciamlogin.com/', // Replace the placeholder with your tenant subdomain
    authority:
      "https://login.microsoftonline.com/"+auth_guid.local.appId,
    redirectUri: "/", // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
    postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            // console.error(message);
            return;
          case LogLevel.Info:
            //console.info(message);
            return;
          case LogLevel.Verbose:
            //console.debug(message);
            return;
          case LogLevel.Warning:
            //console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [],
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
// export const silentRequest = {
//     scopes: ["openid", "profile"],
//     loginHint: "example@domain.net"
// };

// export const b2cPolicies = {
//     names: {
//         SignIn: 'B2C_1_signindefault',
//         forgotPassword : 'B2C_1_reset-pw-default'
//     },
//     authorities: {
//         signUpSignIn: {
//             authority: "https://CBEWebApp.b2clogin.com/CBEWebApp.onmicrosoft.com/B2C_1_signindefault",
//         },
//         forgotPassword: {
//             authority: "https://CBEWebApp.b2clogin.com/CBEWebApp.onmicrosoft.com/B2C_1_reset-pw-default",
//         },
//     },
//     authorityDomain: "CBEWebApp.b2clogin.com"
// };

// export const msalConfig = {
//     auth: {
//         clientId: '8d1aa8d9-20c7-4296-8fbb-9aac1231f7b2',
//         authority: b2cPolicies.authorities.signUpSignIn.authority,
//         knownAuthorities: [b2cPolicies.authorityDomain],
//         redirectUri: '/',
//     },
//     cache: {
//       cacheLocation: 'localStorage',
//       storeAuthStateInCookie: true,
//     },
// }

// export const protectedResources = {
//     todoListApi: {
//       endpoint: "https://localhost:7252/api/Project/GetAllActiveProjects",
//       scopes: ["https://CBEWebApp.onmicrosoft.com/tasks-api/tasks.read"],
//     },
//   }
